import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import '../css/InvestmentOptions.css';

class InvestmentOptions extends Component{
    constructor(props){
        super(props)
        this.state = {
            loading: true,
            usrMemberSetId: null
        }
    }

    static getDeriveStateFromProps(props, state){
        return {
            usrMemberSetId: props.match.params.usrMemberSetId
        }
    }

    componentDidMount(){
        this.props.startLoadingMemberFutureStrategy(this.props.match.params.usrMemberSetId);
    }

    // makeColumns(){
    //     this.props.futureStrategy.
    // }

    render(){
        const {t} = this.props
        //const slPercent = []
        return(
            <div>
                <h3>{t('futureStrategy:InvestmentOptionsAvailable')}</h3>

                <table className="investmentOptions table-responsive superlifeLegacyPlan" style={{marginLeft: "10px", marginRight: "1px"}}>
                    <tbody>
                        {
                            this.props.futureStrategy.investmentOptions.map((investmentOption,index) => 
                            index <= 0 ? 
                            <tr style={{fontWeight: "bold"}}>
                                <th>{investmentOption.col1name}</th>
                                <th>{investmentOption.col2name}</th>
                                <th>{investmentOption.col3name}</th>
                                <th>{investmentOption.col4name}</th>
                            </tr>
                            :
                            <tr>
                                <td><a href={investmentOption.col1link} target="_blank">{investmentOption.col1name}<sup>{investmentOption.col1superscript}</sup></a></td>
                                <td><a href={investmentOption.col2link} target="_blank">{investmentOption.col2name}<sup>{investmentOption.col2superscript}</sup></a></td>
                                <td><a href={investmentOption.col3link} target="_blank">{investmentOption.col3name}<sup>{investmentOption.col3superscript}</sup></a></td>
                                <td><a href={investmentOption.col4link} target="_blank">{investmentOption.col4name}<sup>{investmentOption.col4superscript}</sup></a></td>
                            </tr>
                            )

                        }
                    </tbody>
                </table>
            </div>
        )
    }
}
export default withTranslation()(InvestmentOptions);